import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from "reactstrap";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

import { selectCurrentUser } from "../../../store/redux/api/auth/authSlice";
import { getUserGroups } from "../../../utils/roleUtils";

/**
 * Меню профиля в шапке.
 *
 * Показывает, КТО вошёл и с какими ролями: без этого пользователь с пустым
 * `roles` видел приложение без единого контрола и пустые списки, не понимая
 * причины и не имея возможности назвать поддержке свои роли.
 */
const ProfileMenu = (props) => {
  const [menu, setMenu] = useState(false);
  const user = useSelector(selectCurrentUser);
  const roles = getUserGroups(user).map((group) => group.name);
  const orgSlugs = Array.isArray(user?.org_slugs) ? user.org_slugs : [];
  const displayName = user?.username || user?.email || props.t("profileMenu.anonymous");

  return (
    <React.Fragment>
      <Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className="d-inline-block">
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
          aria-label={props.t("a11y.profileMenu")}
        >
          <i className="mdi mdi-account-circle font-size-28 text-muted align-middle"></i>
        </DropdownToggle>
        <DropdownMenu className="drop-blob">
          {/* Шапка: кто вошёл, роли и организации (диагностика прав доступа) */}
          <div className="px-3 py-2" style={{ minWidth: "16rem" }}>
            <div className="text-muted font-size-11 text-uppercase">
              {props.t("profileMenu.signedInAs")}
            </div>
            <div className="fw-semibold text-truncate">{displayName}</div>
            {user?.email && user.email !== displayName ? (
              <div className="text-muted font-size-12 text-truncate">{user.email}</div>
            ) : null}

            <div className="mt-2">
              <div className="text-muted font-size-11 text-uppercase">
                {props.t("profileMenu.roles")}
              </div>
              {roles.length ? (
                <div className="d-flex flex-wrap gap-1 mt-1">
                  {roles.map((role) => (
                    <Badge key={role} color="primary" className="bg-primary-subtle text-primary">
                      {role}
                    </Badge>
                  ))}
                </div>
              ) : (
                <div className="text-danger font-size-12">
                  <i className="mdi mdi-alert-outline me-1" aria-hidden="true" />
                  {props.t("profileMenu.noRoles")}
                </div>
              )}
            </div>

            <div className="mt-2">
              <div className="text-muted font-size-11 text-uppercase">
                {props.t("profileMenu.organizations")}
              </div>
              {orgSlugs.length ? (
                <div className="d-flex flex-wrap gap-1 mt-1">
                  {orgSlugs.map((slug) => (
                    <Badge key={slug} color="light" className="text-body border">
                      {slug}
                    </Badge>
                  ))}
                </div>
              ) : (
                <div className="text-muted font-size-12">{props.t("profileMenu.noOrgs")}</div>
              )}
            </div>
          </div>

          <div className="dropdown-divider" />

          <DropdownItem tag={Link} to="/profile">
            <i className="mdi mdi-account-circle font-size-17 text-muted align-middle me-1" />
            {props.t("profileMenu.profile")}
          </DropdownItem>
          <DropdownItem tag={Link} to="/my-sites">
            <i className="mdi mdi-office-building-marker-outline font-size-17 text-muted align-middle me-1" />
            {props.t("profileMenu.mySites")}
          </DropdownItem>

          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item text-danger">
            <i className="mdi mdi-power font-size-17 text-muted align-middle me-1 text-danger" />
            <span>{props.t("profileMenu.logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withRouter(withTranslation()(ProfileMenu));
